// TODO add enhanced match email hash to uncached pages like cart and purchase confirmation page
// TODO check if more values can be passed to product and category pages
// TODO look into how Pinterest handles variants separately https://developers.pinterest.com/docs/tag/conversion/

/**
 * Copyright 2025 SweetCode. All rights reserved.
 *
 * Pinterest browser tag functions (free tier)
 *
 * Everything the Pinterest tag needs to load and fire browser events, plus the
 * product formatting the adapter attaches to every event. The API for
 * Conversions helpers (user data, click ID validation, server payload) live in
 * functions_premium.js.
 * */

(function (pmw, undefined) {

	pmw.getPinterestProductData = product => {

		if (product.is_variation) {
			return {
				product_name      : product.name,
				product_variant_id: product.dyn_r_ids[pmwDataLayer.pixels.pinterest.dynamic_remarketing.id_type],
				// product_id        : pmwDataLayer.products[product.parent_id].dyn_r_ids[pmwDataLayer.pixels.pinterest.dynamic_remarketing.id_type],
				product_id      : product.parent_id_dyn_r_ids[pmwDataLayer.pixels.pinterest.dynamic_remarketing.id_type],
				product_category: product.category,
				product_variant : product.variant,
				product_price   : product.price,
				product_quantity: product.quantity,
				product_brand   : product.brand,
			}
		} else {
			return {
				product_name    : product.name,
				product_id      : product.dyn_r_ids[pmwDataLayer.pixels.pinterest.dynamic_remarketing.id_type],
				product_category: product.category,
				product_price   : product.price,
				product_quantity: product.quantity,
				product_brand   : product.brand,
			}
		}
	}

	pmw.pinterestFormattedOrderItems = () => {

		let orderItems = []

		Object.values(pmwDataLayer.order.items).forEach((item) => {

			const parentProduct = pmw.getDataLayerProduct(item.id)
			const useVariation  = pmwDataLayer?.shop?.variations_output && 0 !== item.variation_id
			const product       = useVariation ? pmw.getDataLayerProduct(item.variation_id) : parentProduct

			// A product deleted since the order was placed has no data left to
			// report. Skip the line rather than lose the whole conversion.
			if (!product) {
				pmw.console.warn("Pinterest: skipped an order item without product data: " + item.id)
				return
			}

			const orderItem = {
				product_category: ( parentProduct?.category || [] ).join(","),
				product_quantity: item.quantity,
				product_price   : item.price,
				product_id      : String(product.dyn_r_ids[pmwDataLayer.pixels.pinterest.dynamic_remarketing.id_type]),
				product_name    : product.name,
			}

			// Pinterest reads the brand off the checkout event and reports it
			// as a coverage gap when it is absent. It sits on the parent
			// product, since a variation carries no brand taxonomy of its own.
			const brand = parentProduct?.brand || product?.brand
			if (brand) orderItem.product_brand = brand

			if (product?.variant) orderItem.product_variant = product.variant

			orderItems.push(orderItem)
		})

		return orderItems
	}

	// https://developers.pinterest.com/docs/tag/conversion/
	pmw.loadPinterestPixel = () => {

		try {
			// @formatter:off
			!function(e){if(!window.pintrk){window.pintrk=function(){window.pintrk.queue.push(
				Array.prototype.slice.call(arguments))};var
				n=window.pintrk;n.queue=[],n.version="3.0";var
				t=document.createElement("script");t.async=!0,t.src=e;var
				r=document.getElementsByTagName("script")[0];r.parentNode.insertBefore(t,r)}}("https://s.pinimg.com/ct/core.js");

			pmw.pinterestLoadEvent();
			pintrk('page');
			// @formatter:on

			pmwDataLayer.pixels.pinterest.loaded = true

		} catch (e) {
			console.error(e)
		}
	}

	// https://help.pinterest.com/en/business/article/enhanced-match
	pmw.pinterestLoadEvent = () => {
		try {
			if (isEnhancedMatchActive()) {
				pintrk("load", pmwDataLayer.pixels.pinterest.pixel_id, {em: pmwDataLayer.user.email.sha256})
				return
			}

			pintrk("load", pmwDataLayer.pixels.pinterest.pixel_id)

		} catch (e) {
			console.error(e)
		}
	}

	/**
	 * Check if enhanced match is active
	 * and if the user has an email hash
	 *
	 * Enhanced Match is a Pro setting and the email hash is only in the data
	 * layer on Pro, so this is always false on a free install.
	 *
	 * @return {boolean}
	 */
	const isEnhancedMatchActive = () => {
		if (!pmwDataLayer?.pixels?.pinterest?.enhanced_match) return false
		if (!pmwDataLayer?.user?.email?.sha256) return false

		return true
	}

	/**
	 * Product custom data in the shape the adapter attaches to every
	 * product-level event. Pure product formatting, no user data.
	 */
	pmw.pinterestGetProductDataForCapiEvent = (product) => {

		const content = {
			id        : pmw.getProductIdForSpecificPixel(product, "pinterest"),
			item_price: String(product.price),
			quantity  : product.quantity,
			item_name : product.name,
		}

		// Pinterest asks for the brand and the category on every product-level
		// event and reports their absence as a coverage gap.
		if (product.brand) content.item_brand = product.brand

		const category = Array.isArray(product.category) ? product.category[0] : product.category
		if (category) content.item_category = category

		return {
			currency   : pmw.getProductCurrency(product),
			value      : String(product.price * product.quantity),
			content_ids: [String(product.dyn_r_ids[pmwDataLayer.pixels.pinterest.dynamic_remarketing.id_type])],
			num_items  : 1,
			contents   : [content],
		}
	}

	/**
	 * Check if the Pinterest event can be fired
	 *
	 * @return {boolean}
	 */
	pmw.canFirePinterestEvent = () => {

		if (!pmwDataLayer?.pixels?.pinterest?.loaded) return false

		// If the user has not given consent for marketing, return false
		if (!pmw.consent.categories.get().marketing) return false

		return true
	}

	/**
	 * Check if the Pinterest event can not be fired
	 *
	 * @return {boolean}
	 */
	pmw.canNotFirePinterestEvent = () => {
		return !pmw.canFirePinterestEvent()
	}

}(window.pmw = window.pmw || {}));
